import {
  AUTH_MODE,
  BUYER_INFO_EXTRATION_MODE,
  CART_MODE,
  CONFIRM_SALE_MODE,
  WAITING_CONFIRMATION_MODE,
  PAYMENT_MODE,
  SUCCESSFUL_PAYMENT,
} from '@src/components/Checkout/constants';

export type CheckoutRoutingMode = 'memory' | 'hash';

export const CHECKOUT_ROUTE_PATHS = {
  [CART_MODE]: '/cart',
  [AUTH_MODE]: '/auth',
  [CONFIRM_SALE_MODE]: '/confirm-sale',
  [WAITING_CONFIRMATION_MODE]: '/awaiting-confirmation',
  [PAYMENT_MODE]: '/payment',
  [BUYER_INFO_EXTRATION_MODE]: '/buyer-info',
  [SUCCESSFUL_PAYMENT]: '/successful',
} as const;

export type CheckoutRouteMode = keyof typeof CHECKOUT_ROUTE_PATHS;
export type CheckoutRoutePath = (typeof CHECKOUT_ROUTE_PATHS)[CheckoutRouteMode];

const PATH_TO_MODE = Object.fromEntries(
  (Object.entries(CHECKOUT_ROUTE_PATHS) as [CheckoutRouteMode, CheckoutRoutePath][]).map(([mode, path]) => [
    path,
    mode,
  ]),
) as Record<CheckoutRoutePath, CheckoutRouteMode>;

export const resolveCheckoutRouting = (value: string | undefined): CheckoutRoutingMode | null => {
  if (value === 'memory' || value === 'hash') {
    return value;
  }

  return null;
};

export const modeToPath = (mode: CheckoutRouteMode): CheckoutRoutePath => CHECKOUT_ROUTE_PATHS[mode];

export const pathToMode = (pathname: string): CheckoutRouteMode | null => {
  const normalized = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;

  return (PATH_TO_MODE as Record<string, CheckoutRouteMode>)[normalized] ?? null;
};
